import React, { ComponentProps } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import DialogTitle from './DialogTitle';

export interface AlertDialogProps {
  title: string
  message: ComponentProps<any>['children']
  okText: string
  callback: () => void
}

const AlertDialog = (props: AlertDialogProps) => {
  return (
    <Dialog open={true} onClose={() => props.callback()}>
      <DialogTitle onClose={() => props.callback()}>{props.title}</DialogTitle>
      <DialogContent>
        {(() => {
          if (typeof props.message === 'string')
            return (<DialogContentText>{props.message}</DialogContentText>);
          return props.message;
        })()}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.callback()} color="primary" autoFocus>
          {props.okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;